<template>
  <div class="tax-table-wrap tax-table-wrap-tax53" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>广告费和业务宣传费等跨年度纳税调整明细表</dt>

      <dd></dd>
    </dl>

    <div class="tax-table-body">
      <table border="1" cellspacing="0" cellpadding="4" tabletype="2024033113">
        <thead>
          <tr>
            <td class="title01" rowspan="2" style="width: 70px">行次</td>
            <td class="title01" rowspan="2">项目</td>
            <td class="title01">广告费和业务宣传费</td>
            <td class="title01">保险企业手续费及佣金支出</td>
          </tr>
          <tr>
            <td class="title01">1</td>
            <td class="title01">2</td>
          </tr>
        </thead>
        <tbody>
          <tr class="tr">
            <td class="title01">1</td>
            <td class="td_l title01">一、本年支出</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v1x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td><el-input-number v-model.trim="data.v1x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">2</td>
            <td class="td_l title01" style="padding-left: 28px">减：不允许扣除的支出</td>
            <td><el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td><el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">3</td>
            <td class="td_l title01">二、本年符合条件的支出（1-2）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v3x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v3x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v3x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>{{ parseFloatNum(data.v3x2.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">4</td>
            <td class="td_l title01">三、本年计算扣除限额的基数</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v4x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v4x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v4x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v4x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td><el-input-number v-model.trim="data.v4x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">5</td>
            <td class="td_l title01" style="padding-left: 28px">乘：税收规定扣除率</td>
            <td class="i-1">{{ data.v5x1.value * 100 }}%</td>
            <td>{{ data.v5x2.value * 100 }}%</td>
          </tr>
          <tr class="tr">
            <td class="title01">6</td>
            <td class="td_l title01">四、本企业计算的扣除限额（4×5）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v6x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v6x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>{{ parseFloatNum(data.v6x2.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">7</td>
            <td class="td_l title01">五、本年结转以后年度扣除额（3＞6，本行=3-6；3≤6，本行=0）</td>
            <td>{{ parseFloatNum(data.v7x1.value) }}</td>
            <td>{{ parseFloatNum(data.v7x2.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">8</td>
            <td class="td_l title01" style="padding-left: 28px">加：以前年度累计结转扣除额</td>
            <td><el-input-number v-model.trim="data.v8x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td><el-input-number v-model.trim="data.v8x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">9</td>
            <td class="td_l title01" style="padding-left: 28px">减：本年扣除的以前年度结转额[3＞6，本行=0；3≤6，本行=8与（6-3）孰小值]</td>
            <td>{{ parseFloatNum(data.v9x1.value) }}</td>
            <td>{{ parseFloatNum(data.v9x2.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">10</td>
            <td class="td_l title01">六、按照分摊协议归集至其他关联方的金额（10≤3与6孰小值）</td>
            <td><el-input-number v-model.trim="data.v10x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td><el-input-number v-model.trim="data.v10x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">11</td>
            <td class="td_l title01" style="padding-left: 28px">按照分摊协议从其他关联方归集至本企业的金额</td>
            <td><el-input-number v-model.trim="data.v11x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td><el-input-number v-model.trim="data.v11x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">12</td>
            <td class="td_l title01">七、本年支出纳税调整金额（3＞6，本行=2+3-6+10-11；3≤6，本行=2+10-11-9）</td>
            <td>{{ parseFloatNum(data.v12x1.value) }}</td>
            <td>{{ parseFloatNum(data.v12x2.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">13</td>
            <td class="td_l title01">八、累计结转以后年度扣除额（7+8-9）</td>
            <td>{{ parseFloatNum(data.v13x1.value) }}</td>
            <td>{{ parseFloatNum(data.v13x2.value) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep, includes } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";
import { syncAnswer } from "../../cmjs/index.js";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

const watchData = computed(() => cloneDeep(data.value));
function watchStart() {
  watch(
    watchData,
    (newVal, oldVal) => {
      try {
        for (let column = 1; column <= 2; column++) {
          // 1-2列 3行=1-2
          data.value[`v3x${column}`].value = new Big(data.value[`v1x${column}`].value).minus(data.value[`v2x${column}`].value).round(2).toNumber();
          // 1-2列 6=4×5
          data.value[`v6x${column}`].value = new Big(data.value[`v4x${column}`].value).times(data.value[`v5x${column}`].value).round(2).toNumber();
        }

        syncAnswer({
          mode,
          newVal,
          oldVal,
          data,
        });
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  table {
    tbody {
      tr {
        td {
          &:nth-of-type(2) {
            text-align: left;
          }
        }
      }
    }
  }
}
</style>

<script>
const tableHtml = `
<table border="1" cellspacing="0" cellpadding="4" tabletype="2024033113">
  <thead>
    <tr>
      <td class="title01" rowspan="2" style="width: 70px">行次</td>
      <td class="title01" rowspan="2">项目</td>
      <td class="title01">广告费和业务宣传费</td>
      <td class="title01">保险企业手续费及佣金支出</td>
    </tr>
    <tr>
      <td class="title01">1</td>
      <td class="title01">2</td>
    </tr>
  </thead>
  <tbody>
    <tr class="tr">
      <td class="title01">1</td>
      <td class="td_l title01">一、本年支出</td>
      <td><input type="text" value="0" class="i1 input2" daan="59806.62" /></td>
      <td><input type="text" value="0" class="i1-1 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">2</td>
      <td class="td_l title01">减：不允许扣除的支出</td>
      <td><input type="text" value="0" class="i2 input2" daan="0.00" /></td>
      <td><input type="text" value="0" class="i2-1 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">3</td>
      <td class="td_l title01">二、本年符合条件的支出（1-2）</td>
      <td><input type="text" value="0" class="i3 input1" daan="59806.62" /></td>
      <td><input type="text" value="0" class="i3-1 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">4</td>
      <td class="td_l title01">三、本年计算扣除限额的基数</td>
      <td><input type="text" value="0" class="i4 input2" daan="10821684.02" /></td>
      <td><input type="text" value="0" class="i4-1 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">5</td>
      <td class="td_l title01">乘：税收规定扣除率</td>
      <td class="i-1">
        <input type="text" style="display: none" daan="0.00" />
        <select class="input2" name="" id="">
          <option value="15">15%</option>
          <option value="30">30%</option>
          <option value="0">0</option>
        </select>
      </td>
      <td style="text-align: right">
        <div class="i5-1 input1">18%</div>
      </td>
    </tr>
    <tr class="tr">
      <td class="title01">6</td>
      <td class="td_l title01">四、本企业计算的扣除限额（4×5）</td>
      <td><input type="text" value="0" class="i6 input1" daan="1623252.60" /></td>
      <td><input type="text" value="0" class="i6-1 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">7</td>
      <td class="td_l title01">五、本年结转以后年度扣除额（3＞6，本行=3-6；3≤6，本行=0）</td>
      <td><input type="text" value="0" class="i7 input1" daan="0.00" /></td>
      <td><input type="text" value="0" class="i7-1 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">8</td>
      <td class="td_l title01">加：以前年度累计结转扣除额</td>
      <td><input type="text" value="0" class="i8 input2" daan="0.00" /></td>
      <td><input type="text" value="0" class="i8-1 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">9</td>
      <td class="td_l title01">减：本年扣除的以前年度结转额[3＞6，本行=0；3≤6，本行=8与（6-3）孰小值]</td>
      <td><input type="text" value="0" class="i9 input1" daan="0.00" /></td>
      <td><input type="text" value="0" class="i9-1 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">10</td>
      <td class="td_l title01">六、按照分摊协议归集至其他关联方的金额（10≤3与6孰小值）</td>
      <td><input type="text" value="0" class="i10 input2" daan="0.00" /></td>
      <td><input type="text" value="0" class="i10-1 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">11</td>
      <td class="td_l title01">按照分摊协议从其他关联方归集至本企业的金额</td>
      <td><input type="text" value="0" class="i11 input2" daan="0.00" /></td>
      <td><input type="text" value="0" class="i11-1 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">12</td>
      <td class="td_l title01">七、本年支出纳税调整金额（3＞6，本行=2+3-6+10-11；3≤6，本行=2+10-11-9）</td>
      <td><input type="text" value="0" class="i12 input1" daan="0.00" /></td>
      <td><input type="text" value="0" class="i12-1 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">13</td>
      <td class="td_l title01">八、累计结转以后年度扣除额（7+8-9）</td>
      <td><input type="text" value="0" class="i13 input1" daan="0.00" /></td>
      <td><input type="text" value="0" class="i13-1 input1" daan="0.00" /></td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input.*type="text".*none.*>/g, "");
  s = s.replace(/<input.*type="text".*>/g, '<el-input-number v-model.trim="defaultValue" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValue = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
